import { DOCS_LINK } from 'src/app/app-config';
import { Role } from 'src/app/theme/shared/_helpers/role';

export interface NavigationItem {
  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: NavigationItem[];
  role?: string[];
  disabled?: boolean;
  isMainParent?: boolean;
}

export const NavigationItems: NavigationItem[] = [
  {
    id: 'company_management_group',
    title: 'Company Details',
    type: 'group',
    icon: 'feather icon-settings',
    role: [Role.Admin, Role.SuperAdmin],
    isMainParent: true,

    children: [
      {
        id: 'company_management',
        title: 'Company Details',
        type: 'collapse',
        icon: 'feather icon-briefcase',
        role: [Role.Admin, Role.SuperAdmin],
        children: [
          {
            id: 'company_view_user',
            title: 'View Companies',
            type: 'item',
            url: '/admin/company/list'
          },
          {
            id: 'company_add_user',
            title: 'Add Companies',
            type: 'item',
            url: '/admin/company/add'
          }
        ]
      }
    ]
  },
  {
    id: 'client_user_management_group',
    title: 'Client Users',
    type: 'group',
    icon: 'feather icon-settings',
    role: [Role.Admin, Role.SuperAdmin],
    isMainParent: true,
    children: [
      {
        id: 'client_user_management',
        title: 'User Management',
        type: 'collapse',
        icon: 'feather icon-briefcase',
        role: [Role.Admin, Role.SuperAdmin],
        children: [
          {
            id: 'client_view_user',
            title: 'View Users',
            type: 'item',
            url: '/admin/client_users/list'
          },
          {
            id: 'client_add_user',
            title: 'Add Users',
            type: 'item',
            url: '/admin/client_users/add'
          }
        ]
      }
    ]
  },
  {
    id: 'admin_user_management_group',
    title: 'Admin Users',
    type: 'group',
    icon: 'feather icon-settings',
    role: [Role.Admin, Role.SuperAdmin],
    isMainParent: true,
    children: [
      {
        id: 'admin_user_management',
        title: 'User Management',
        type: 'collapse',
        icon: 'feather icon-briefcase',
        role: [Role.Admin, Role.SuperAdmin],
        children: [
          {
            id: 'admin_view_user',
            title: 'View Admin Users',
            type: 'item',
            url: '/admin/admin_users/list'
          },
          {
            id: 'admin_add_user',
            title: 'Add Admin Users',
            type: 'item',
            url: '/admin/admin_users/add'
          }
        ]
      }
    ]
  },
  {
    id: 'tenant_management_group',
    title: 'Role Management',
    type: 'group',
    icon: 'feather icon-settings',
    role: [Role.Admin, Role.SuperAdmin],
    children: [
      {
        id: 'roles_management',
        title: 'Role Management',
        type: 'collapse',
        icon: 'feather icon-briefcase',
        role: [Role.Admin, Role.SuperAdmin],
        children: [
          {
            id: 'role_view',
            title: 'View Roles',
            type: 'item',
            url: '/admin/roles/list'
          },
          {
            id: 'role_add',
            title: 'Add Roles',
            type: 'item',
            url: '/admin/roles/add'
          }
        ]
      }
    ]
  },
  {
    id: 'terms_and_conditions_management_group',
    title: 'Terms and Conditions',
    type: 'group',
    icon: 'feather icon-settings',
    role: [Role.Admin, Role.SuperAdmin],
    isMainParent: true,
    children: [
      {
        id: 'terms_and_conditions_management',
        title: 'T&C Management',
        type: 'collapse',
        icon: 'feather icon-briefcase',
        role: [Role.Admin, Role.SuperAdmin],
        children: [
          {
            id: 'terms_and_conditions_view',
            title: 'View',
            type: 'item',
            url: '/admin/terms-and-conditions/list'
          },
          {
            id: 'terms_and_conditions_add',
            title: 'Add',
            type: 'item',
            url: '/admin/terms-and-conditions/add'
          }
        ]
      }
    ]
  },
  {
    id: 'tenant_management_group',
    title: 'Department Management',
    type: 'group',
    icon: 'feather icon-settings',
    role: [Role.Admin, Role.SuperAdmin],
    children: [
      {
        id: 'department_management',
        title: 'Departments',
        type: 'collapse',
        icon: 'feather icon-briefcase',
        role: [Role.Admin, Role.SuperAdmin],
        children: [
          {
            id: 'department_view',
            title: 'View Departments',
            type: 'item',
            url: '/admin/department/list'
          },
          {
            id: 'department_add',
            title: 'Add Departments',
            type: 'item',
            url: '/admin/department/add'
          }
        ]
      }
    ]
  },
  {
    id: 'tenant_management_group',
    title: 'Device Management',
    type: 'group',
    icon: 'feather icon-settings',
    role: [Role.Admin, Role.SuperAdmin],
    children: [
      {
        id: 'device_management',
        title: 'Devices',
        type: 'collapse',
        icon: 'feather icon-briefcase',
        role: [Role.Admin, Role.SuperAdmin],
        children: [
          {
            id: 'device_view',
            title: 'View Devices',
            type: 'item',
            url: '/admin/dev_mgmt/devices'
          }
        ]
      }
    ]
  },
  {
    id: 'ip_address_management',
    title: 'IP Address Management',
    type: 'group',
    icon: 'feather icon-settings',
    role: [Role.Admin, Role.SuperAdmin],
    children: [
      {
        id: 'ip_address_log',
        title: 'IP Address',
        type: 'collapse',
        icon: 'feather icon-briefcase',
        role: [Role.Admin, Role.SuperAdmin],
        children: [
          {
            id: 'ip_address_config',
            title: 'IP Address Config',
            type: 'item',
            url: '/admin/ip-address-mgmt/company-list'
          }
        ]
      }
    ]
  },
  {
    id: 'menu_mgmt',
    title: 'Menu Management',
    type: 'group',
    icon: 'feather icon-settings',
    role: [Role.Admin, Role.SuperAdmin],
    children: [
      {
        id: 'menu',
        title: 'Menu',
        type: 'collapse',
        icon: 'feather icon-briefcase',
        role: [Role.Admin, Role.SuperAdmin],
        children: [
          {
            id: 'menu',
            title: 'Menu',
            type: 'item',
            url: '/admin/menu_mgmt/menu_group/list'
          }
        ]
      }
    ]
  },
  {
    id: 'module_mgmt',
    title: 'Module Management',
    type: 'group',
    icon: 'feather icon-settings',
    role: [Role.Admin, Role.SuperAdmin],
    children: [
      {
        id: 'module',
        title: 'Module',
        type: 'collapse',
        icon: 'feather icon-briefcase',
        role: [Role.Admin, Role.SuperAdmin],
        children: [
          {
            id: 'module',
            title: 'Module',
            type: 'item',
            url: '/admin/module_mgmt/module/list'
          }
        ]
      }
    ]
  },

  {
    id: 'subscription_management',
    title: 'Subscription Management',
    type: 'group',
    icon: 'feather icon-settings',
    role: [Role.Admin, Role.SuperAdmin],
    children: [
      {
        id: 'subscription_plans',
        title: 'Base Plans',
        type: 'collapse',
        icon: 'feather icon-briefcase',
        role: [Role.Admin, Role.SuperAdmin],
        children: [
          {
            id: 'plan_list',
            title: 'View Plans',
            type: 'item',
            url: '/admin/subscription-plan/list'
          },
          {
            id: 'plan_add',
            title: 'Create Plan',
            type: 'item',
            url: '/admin/subscription-plan/add'
          }
        ]
      },
      {
        id: 'company_subscriptions',
        title: 'Company Plans',
        type: 'collapse',
        icon: 'feather icon-users',
        role: [Role.Admin, Role.SuperAdmin],
        children: [
          {
            id: 'company_sub_list',
            title: 'View Company Plans',
            type: 'item',
            url: '/admin/company-subscription-plan/list'
          },
          {
            id: 'company_sub_add',
            title: 'Add Company Plan',
            type: 'item',
            url: '/admin/company-subscription-plan/add'
          },
          {
            id: 'company_sub_logs',
            title: 'Notification Logs',
            type: 'item',
            url: '/admin/company-subscription-plan/notification-log'
          }
        ]
      },
      {
        id: 'billing_history',
        title: 'Invoices',
        type: 'collapse',
        icon: 'feather icon-file-text',
        role: [Role.Admin, Role.SuperAdmin],
        children: [
          {
            id: 'invoice_list',
            title: 'View Invoices',
            type: 'item',
            url: '/admin/company-subscription-invoice/list'
          }
        ]
      }
    ]
  },

  {
    id: 'api_mgmt',
    title: 'Api Management',
    type: 'group',
    icon: 'feather icon-settings',
    role: [Role.Admin, Role.SuperAdmin],
    children: [
      {
        id: 'company_auth',
        title: 'Api',
        type: 'collapse',
        icon: 'feather icon-briefcase',
        role: [Role.Admin, Role.SuperAdmin],
        children: [
          {
            id: 'menu',
            title: 'Auth Type config',
            type: 'item',
            url: '/admin/api_mgmt/company_auth/list'
          },
          {
            id: 'api_config',
            title: 'API Mapping Fields',
            type: 'item',
            url: '/admin/api_mgmt/mapping_list/list'
          },
          {
            id: 'api_config',
            title: 'API Baseurl',
            type: 'item',
            url: '/admin/api_mgmt/baseurl_list/list'
          },
          {
            id: 'api_config',
            title: 'API Scheduler Log',
            type: 'item',
            url: '/admin/api_mgmt/scheduler_log/list'
          }
        ]
      }
    ]
  },
  {
    id: 'monitoring_dashboard',
    title: 'Monitoring Dashboard',
    type: 'group',
    icon: 'feather icon-settings',
    role: [Role.Admin, Role.SuperAdmin],
    children: [
      {
        id: 'dashboards',
        title: 'Dashboards',
        type: 'collapse',
        icon: 'feather icon-briefcase',
        role: [Role.Admin, Role.SuperAdmin],
        children: [
          {
            id: 'login_logout_report_activity_log',
            title: 'Login Activity Dashboard',
            type: 'item',
            url: '/admin/login-logout-report-activity-log/list'
          },
          {
            id: 'server_performance_monitoring',
            title: 'Server Performance Monitoring',
            type: 'item',
            url: '/admin/server-performance-monitoring/server'
          },
          {
            id: 'performance_monitoring',
            title: 'Performance Monitoring',
            type: 'item',
            url: '/admin/performance-monitoring'
          },
          {
            id: 'performance_monitoring',
            title: 'Performance Monitoring',
            type: 'item',
            url: '/admin/performance-monitoring'
          },
          {
            id: 'report_activity_log',
            title: 'Report Activity Dashboard',
            type: 'item',
            url: '/admin/activity-log/report-activity-list'
          },
          {
            id: 'api_exception_monitoring',
            title: 'API Exception Monitoring',
            type: 'item',
            url: '/admin/api-exception-monitoring/list'
          },

        ]
      }
    ]
  },
  {
    id: 'actitvity_log_management',
    title: 'Log Management',
    type: 'group',
    icon: 'feather icon-settings',
    role: [Role.Admin, Role.SuperAdmin],
    children: [
      {
        id: 'activity_log',
        title: 'Activity Log',
        type: 'collapse',
        icon: 'feather icon-briefcase',
        role: [Role.Admin, Role.SuperAdmin],
        children: [
          {
            id: 'user_activity_log',
            title: 'User Activity Log',
            type: 'item',
            url: '/admin/activity-log/user-activity-list'
          }
        ]
      }
    ]
  },
  {
    id: 'export_management_group',
    title: 'Export',
    type: 'group',
    icon: 'feather icon-download',
    role: [Role.Admin, Role.SuperAdmin],
    children: [
      {
        id: 'export_company',
        title: 'Company Export',
        type: 'item',
        url: '/admin/export/company-export'
      }
    ]
  },
];
